/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  // const social = data.site.siteMetadata?.social

  return (
    <div className="bio">
      <StaticImage
        className="bio-avatar"
        layout="fixed"
        formats={["auto", "webp", "avif"]}
        src="../images/Tian_Photo.jpg"
        width={150}
        height={150}
        alt="Profile picture"
      />
      {author?.name && (
        <p>
          <strong>{author.name}</strong> {author?.summary || null}
          {` `}
          is a data science intern at <a href="https://www.westjet.com/">WestJet</a> and previously a research intern at <a href="https://ilab.ucalgary.ca/">UCalgary iLab</a> working on novel interaction techniques in mixed-reality under the supervision of Drs. <a href="https://utouch.cpsc.ucalgary.ca/">Ehud Sharlin</a> and <a href="https://ryosuzuki.org/">Ryo Suzuki</a>.
          <p>Email: tian.xia2 [at] ucalgary.ca</p>
          <a href="https://www.linkedin.com/in/tianxiacs">
            LinkedIn
          </a>
        </p>
      )}
    </div>
  )
}

export default Bio
